import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useCareersHeader } from '../../utilities/static-queries/careers-header';
import { Icon, List } from '@pella/sash-framework';
import { CTA } from '../../';

import styles from './index.module.scss';

const CareersMobileMenu = ({ showMenu, activePage, closeMenu }) => {
	const data = useCareersHeader();
	const [loading, setLoading] = useState(true);
	const [activeTitle, setActiveTitle] = useState('Default');

	// Clicking menu items to slide in the child menu
	const onMenuItemClick = (e) => {
		const parent = e.currentTarget.parentNode.parentNode;
		const siblings = e.currentTarget.parentNode.childNodes;
		const title = e.currentTarget.dataset.title ? e.currentTarget.dataset.title : null;

		if (siblings && siblings.length > 1) {
			parent.scrollTop = 0;
			parent.classList.add(styles.subMenu_List_parent);
			siblings[1].classList.add(styles.subMenu_List_active);

			setActiveTitle(title);
		}
	};

	// Clicking the back button
	const onBackToMenuClick = (e) => {
		const parentList = e.currentTarget.parentNode.parentNode;
		const prevParent = parentList.parentNode.parentNode;
		prevParent.classList.remove(styles.subMenu_List_parent);
		parentList.classList.remove(styles.subMenu_List_active);
	};

	// On anchor link changes of the same page, grab element and closemenu
	// - Trigger the close menu after scrolling to the element on the page
	// - Since the page doesn't change, no reload forces the menu closed
	useEffect(() => {
		let element = document.getElementById(activePage.hash.substring(1));

		if (!loading && element) {
			element?.scrollIntoView({ behavior: 'smooth' });
			closeMenu();
		}

		if (loading) {
			setLoading(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- preexisting failure, fix when possible
	}, [activePage]);

	return (
		<div className={`${styles.mobileMenu} ${showMenu ? styles.mobileMenu_active : ''}`}>
			<List
				bullets='none'
				className={styles.mobileMenu_List}
			>
				{data.navigation?.menu_items?.[0] &&
					data.navigation.menu_items.map((item, index) => (
						<li key={index}>
							{item.dropdown?.[0] && (
								<>
									<button
										onClick={(el) => onMenuItemClick(el)}
										className={styles.mobileMenu_Button}
										data-title={item.menu_heading}
										aria-label={'default'}
									>
										{item.menu_heading}
										<Icon name='keyboard_arrow_right' />
									</button>

									<List
										bullets='none'
										className={styles.subMenu_List}
									>
										<li>
											<button
												onClick={(el) => onBackToMenuClick(el)}
												className={`${styles.mobileMenu_Button} ${styles.subMenu_MainMenuTitle}`}
												aria-label={'default'}
											>
												<Icon name='keyboard_arrow_left' />
												Main Menu
											</button>
										</li>

										<li className={styles.subMenu_ActiveMenuTitle}>{activeTitle}</li>

										{item.dropdown.map((item, index) => (
											<li key={index}>
												{item.ctas?.[0] && (
													<CTA
														data={item.ctas[0]}
														className={styles.subMenu_BaseLink}
													/>
												)}
											</li>
										))}
									</List>
								</>
							)}

							{item.ctas?.[0] && (
								<CTA
									data={item.ctas[0]}
									className={styles.mobileMenu_Button}
								/>
							)}
						</li>
					))}
			</List>
		</div>
	);
};

CareersMobileMenu.propTypes = {
	data: PropTypes.array,
	showMenu: PropTypes.bool,
	activePage: PropTypes.object,
	closeMenu: PropTypes.func,
};

export default CareersMobileMenu;
